import { useMutation, UseMutationOptions } from 'react-query';
import { mutateVoidMarket } from './voidMarket';
import { TVoidMarketBody } from './voidMarket.types';

export const useMutationVoidMarket = (
  options?: UseMutationOptions<unknown, unknown, TVoidMarketBody>
) => useMutation((data) => mutateVoidMarket(data), options);
